import React from 'react';
import { Button, PrimaryButton } from 'app/blocks/buttons/buttons';
import { ID, withCodes2 } from 'app/blocks/common/codes';
import DialogMessage from 'app/blocks/dialog/dialog__message';
import Modal from 'app/blocks/Modal/Modal';

function ConfirmNIHSubscriptionModal(props) {
    const { l, onApprove, onReject } = props;

    return (
        <Modal
            className="Dialog"
            id="confirmNIHSubscriptionModal"
            ignoreBackdropClicks
            onClose={onReject}
            type="confirmation"
        >
            <div className="modal-body Dialog-Body" data-seleniumid="modal-body" style={{ textAlign: 'left' }}>
                <DialogMessage
                    html={l('LICENSE_SIGNING.OPEN_ACCESS.CHECK_NIH_COMPLIANCE_POPUP.TEXT')}
                    type="confirmation"
                />
                <div className="Dialog-BodyActions Dialog-BodyActions-Column">
                    <PrimaryButton data-seleniumid="confirmNIHSubscriptionModal-confirm-button" onClick={onApprove}>
                        {l('LICENSE_SIGNING.OPEN_ACCESS.CHECK_NIH_COMPLIANCE_POPUP.BUTTON_CONFIRM')}
                    </PrimaryButton>
                    <Button
                        className="noStretch"
                        data-seleniumid="confirmNIHSubscriptionModal-cancel-button"
                        onClick={onReject}
                    >
                        {l('BUTTONS.CANCEL')}
                    </Button>
                </div>
            </div>
        </Modal>
    );
}
export { ConfirmNIHSubscriptionModal };
export default withCodes2(ID.LICENSE_SIGNING)(ConfirmNIHSubscriptionModal);
